import React, { Component } from 'react'; 
import HistorialModificaciones from './HistorialModificaciones.jsx'; 

class ModalHistorialModificaciones extends Component {
    constructor(props) {
        super(props);
    }
    render() { 
      
        return (
            <div className="modalContainer">
                <div className='modalHistorialModificacionOutXL' style={{marginRight:"-30px", marginTop:"60px"}}>
                   <HistorialModificaciones datosLogIntentos={this.props.datosLogIntentos }obtenerDatosLogIntentos={this.props.obtenerDatosLogIntentos} IdmodalLogIntentos={this.props.IdmodalLogIntentos} modalLogIntentos={this.props.modalLogIntentos} seccion={this.props.seccion} listaModificaciones={this.props.listaModificaciones} openModalLogIntentos={this.props.openModalLogIntentos} openModal={this.props.openModal}/>
                </div> 
            </div>
        )
    }
}
export default ModalHistorialModificaciones;